
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[partner]/link-your-ups-account",
      function () {
        return require("private-next-pages/partners/[partner]/link-your-ups-account.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/[partner]/link-your-ups-account"])
      });
    }
  